import React from 'react';
import { getConfiguratorMenuOptions, getSelectedConfiguratorMenu } from '../../Reducers/App/Selectors';
import { useSelector, useDispatch } from 'react-redux';
import { useStyles } from './styles';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { setSelectedConfiguratorMenu, setSelectedComponent } from '../../Reducers/App/Actions';

interface MenuItem {
  identifier: string;
  title: string;
}

const ConfiguratorMenu: React.FC = () => {
  const items: MenuItem[] = useSelector(getConfiguratorMenuOptions);
  const selected = useSelector(getSelectedConfiguratorMenu);
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClick = (item) => {
    dispatch(setSelectedConfiguratorMenu(item.identifier));
    dispatch(setSelectedComponent(null));
  };

  return (
    <>
      <div className={classes.root}>
        <List className={classes.listRoot}>
          {items.map((menu) => {
            return (
              <ListItem
                key={menu.identifier}
                className={classes.listItem}
                selected={menu.identifier === selected}
              >
                {' '}
                <ListItemText className={classes.listText} onClick={() => handleClick(menu)}>
                  {menu.title}
                </ListItemText>{' '}
              </ListItem>
            );
          })}
        </List>
      </div>
    </>
  );
};

export default ConfiguratorMenu;
